export function createSettingsGuideUseCase(settingsGuidelData, settingsGuideRepository) {
    const settings_guide = new settingsGuideRepository.model(settingsGuidelData);
  
    if (!settings_guide.isValid()) {
      throw new Error("settings guide inválido");
    }
  
    return settingsGuideRepository.save(settings_guide);
}